import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { translate } from 'services/i18nService';
import UserStore from 'stores/UserStore';
import allUserGroups from 'enum/userGroups';

import styles from './index.css';


const TokenUpchargeDisclaimer = (props) => {
  const { className, shouldForceDisplay } = props;

  const { user: { tokenUpchargePercentage } } = UserStore;

  let applyUpchargePercentage = undefined;
  if (UserStore.hasCF(allUserGroups.USE_UPCHARGE)) {
    applyUpchargePercentage = tokenUpchargePercentage;
  }

  if (!applyUpchargePercentage && !shouldForceDisplay) {
    return null;
  }

  const clases = classNames(styles.tokenUpchargeDisclaimer, className);

  return (
    <div className={clases}>
      {translate('v2profile.vat.info')}
    </div>
  );
};

TokenUpchargeDisclaimer.propTypes = {
  className: PropTypes.string,
  shouldForceDisplay: PropTypes.bool,
};

TokenUpchargeDisclaimer.defaultProps = {
  className: undefined,
  shouldForceDisplay: false,
};

export default TokenUpchargeDisclaimer;
